import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "./../../services/http.service";
import { ToolsService } from "./../../services/tools.service";
import { BanqueDialogComponent } from "./banque-dialog";
import { ToastrService } from "./../../components/_toastr/toastr.service";
import { Banque } from "../../interfaces/Banque";

@Injectable({
  providedIn: "root",
})
export class BanqueDialogService {
  constructor(
    private _dialog: MatDialog,
    private _http: HttpService,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  openDialog(banque_ID: number, callBack: Function = () => {}): void {
    const dialogRef = this._dialog.open(BanqueDialogComponent, {
      width: "700px",
      data: banque_ID,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  get(banque_ID: number, callBack: Function): void {
    this._http.GET(
      "/api/banque/" + banque_ID,
      null,
      (result) => {
        if (result.isOk) {
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  post(banque: Banque, callBack: Function): void {
    this._http.POST(
      "/api/banque",
      banque,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Compte administré enregistré avec succès",
            type: "success",
          });
          // Retourner l'objet mis à jour avec le nouvel ID si c'est une création
          if (result.obj && result.obj.session_ID) {
            callBack(result.obj);
          } else {
            callBack(banque);
          }
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  delete(banque_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/banque/" + banque_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Banque supprimée avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
